module.exports = __webpack_public_path__ + "img/T5-B-xh8.42dec65b.png";